import moment from 'moment';
import BN from 'bignumber.js';

export function reasonForUnbalanced(tx) {
  if (!tx.splits) {
    return 'No detail available';
  }
  const dwollaCb = tx.splits.filter(s => s.counterparty === 'dwolla' && s.amount > 0);
  if (dwollaCb.length) {
    const last = dwollaCb[dwollaCb.length - 1];
    if (last.extra_data) {
      return `${last.extra_data.desc} (${last.extra_data.code})`;
    }
  }
  if (!tx.splits.find(s => s.split_type === 'discount')) {
    return 'No discount';
  }
  const dwolla = tx.splits.filter(s => s.counterparty === 'dwolla' && s.amount < 0);
  const decl = tx.splits.filter(s => s.counterparty === 'dwolla'
    && s.amount < 0 && s.split_status === 'declined');
  if (dwolla.length === decl.length && decl.length) {
    return 'Dwolla decline';
  }
  const txAmount = new BN(tx.amount);
  if (txAmount.lt(0)) {
    return 'Negative Total';
  }
  if (!tx.splits.find(s => s.split_type === 'payment')) {
    const [purchaseSplit] = tx.splits.filter(s => s.split_type === 'purchase');
    const purchaseDate = new moment(purchaseSplit.created_at); // eslint-disable-line
    const now = new moment(); // eslint-disable-line
    if (moment.duration(now.diff(purchaseDate)).as('hours') < 36) {
      return 'Balance check block';
    }
  }
  return 'Unknown';
}

export function transactionDate(tx) {
  const wexSplit = tx.splits.filter(s => s.counterparty === 'wex');
  if (wexSplit) {
    return wexSplit.created_at || tx.created;
  }
  return tx.created;
}
